export enum BuyProductCommissionRateTypeEnum {
  PERCENTAGE = "percentage",
  FIXED = "fixed",
}
